import { render } from "./Register.vue?vue&type=template&id=a2f4bfac&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=a2f4bfac&scoped=true&lang=css"
import "./Register.vue?vue&type=style&index=1&id=a2f4bfac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f4bfac"]])

export default __exports__